export const fontOverflowWrapTokens = () => {
  return 'unset';
};
export const fontOverflowWrapTokensNova = () => {
  return 'normal';
};
//# sourceMappingURL=fontOverflowWrap.js.map